import React, { useState } from "react";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const contacts = [
    "📍 Mahimanagar, Nayabazar, Cuttack-753004, Odisha",
    "📱 Mobile: 9861006393",
    "💬 WhatsApp: 9040631984",
    "✉️ Email: debasis399@gmail.com",
  ];

  return (
    <header className="header">
      <div className="header-layout">
        
        {/* Logo */}
        <div className="logo-box">
          <span className="logo">NSS</span>
        </div>

        {/* Company Name + Scrolling Contacts */}
        <div className="company-box">
          <h1 className="company-title">NARMADA SOLAR SOLUTIONS</h1>
          <div className="rotating-contacts">
            <div className="contact-rotate">
              {contacts.map((contact, idx) => (
                <span key={idx} className="contact-line">
                  {contact} &nbsp;&nbsp;&nbsp;
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Hamburger Menu */}
        <div
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      {/* Overlay for dim background */}
      <div
        className={`overlay ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen(false)}
      ></div>

      {/* Mobile Navigation */}
      <nav className={`mobile-nav ${menuOpen ? "active" : ""}`}>
        <ul className="mobile-nav-menu">
          {["Home", "About", "Services", "Gallery", "Contact"].map((item) => (
            <li key={item}>
              <a
                href={`#${item.toLowerCase()}`}
                className="mobile-nav-link"
                onClick={() => setMenuOpen(false)}
              >
                {item}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}
